<template>
  <div class="sign-in-section">

  	<form class="sign-in-form" @submit.prevent="submit" style="width: 50%;">

      <div class="sign-in-text">
        Please register your account
      </div>

      <!--
      <div v-if='messages' v-for='message in messages' :key='message' class="messages-section">
        {{message}}
      </div>
      -->

      <div class="email">
        <v-text-field label="Name" :rules="rules" v-model="form.name"></v-text-field>
      </div>
  		<div class="email">
        <v-text-field type="email" label="Email" :rules="rules" v-model="form.email"></v-text-field>
  		</div>
  		<div class="password">
        <v-text-field id="password" type="password" name="password" label="Password" :rules="rules" v-model="form.password"></v-text-field>
  		</div>
      <div class="confirm-password">
        <v-text-field id="password" type="password" name="password_confirmation" label="Confirm Password" :rules="rules" v-model="form.password_confirmation"></v-text-field>
      </div>
  		<div class="submit">
        <v-btn
          depressed
          color="primary"
          style='margin-top: 15px;'
          type="submit"
        >
          Register
        </v-btn>
  		</div>
  	</form>

  </div>
</template>

<script>
	import { mapActions} from 'vuex'
  import api from '@/api'
  import messageMixin from '@/mixin/messageMixin'

export default {
  name: 'Register',
  mixins: [messageMixin],
  components: {

  },

  data () {
  	return {
  		form: {
        name: '',
	  		email: '',
        role: 'user',
	  		password: '',
        password_confirmation: ''
	  	},
      messages: [],
      rules: [
        value => !!value || 'Required.',
        value => (value && value.length >= 3) || 'Min 3 characters',
      ],
  	}
  },

  methods: {
  	...mapActions({
  		signIn: 'auth/signIn'
  	}),

  	submit () {
      this.messages = []

      if(this.form.password != this.form.password_confirmation) {
        this.messages.push('Password does not match!')
      } else {
        console.log('submit', this.form)
        this.register(this.form)
      }
  	},

    async register (data) {

      const response = await api.auth.register(data)
      if (response.status < 300) {
        this.logIn(data)
        console.log('response', response)
      } else {
        console.log('response BAD')
      }
    },

    async logIn (credentials) {

      const response = await api.auth.login(credentials)
      if (response.status < 300) {
        console.log('response', response)
      } else {
        console.log('response BAD')
      }

      if (response.error) {
        this.displayError(response.error)
        return
      }
      //redirect
      this.$router.push('/project-details')
    },

    resetForm () {
      this.form.name = ''
      this.form.email = ''
      this.form.role = 'user'
      this.form.password = ''
      this.form.password_confirmation = ''
    }
  }
}
</script>

<style lang="scss" scoped>

  .sign-in-text {
    margin-top: 60px;
    font-size: 20px;
    font-weight: 600;
  }
</style>
